// Copyright (c) 2016 Deere & Company

import {combineReducers} from 'redux';
import downTime from './shared/reducers/down-time';
import {getCombinedReducers as getCombinedAllClaimsReducers} from './all-claims/reducers';
import {getCombinedReducers as getCombinedAttachmentClaimReducers} from './attachment/reducers';
import {getCombinedReducers as getCombinedBatteryClaimReducers} from './battery/reducers';
import {getCombinedReducers as getCombinedClaimSearchReducers} from './claim-search/reducers';
import {getCombinedReducers as getCombinedClaimsInProgressReducers} from './claims-in-progress/reducers';
import {getCombinedReducers as getCombinedDealerInvoiceReducers} from './dealer-invoices/reducers';
import {getCombinedReducers as getCombinedIncentiveClaimReducers} from './incentive/reducers';
import {getCombinedReducers as getCombinedJdpClaimReducers} from './marketing/jdp/reducers';
import {getCombinedReducers as getCombinedLaborRateChangeReducers} from './labor-rate-change/reducers';
import {getCombinedReducers as getCombinedLaborRateDealersReducers} from './labor-rate-dealers/reducers';
import {getCombinedReducers as getCombinedMaintenancePlanClaimReducers} from './marketing/maintenance-plan/reducers';
import {getCombinedReducers as getCombinedMassChannelPdiClaimReducers} from './marketing/mass-channel-pdi/reducers';
import {getCombinedReducers as getCombinedMassLaborRateChangeReducers} from './mass-labor-rate-change/reducers';
import {getCombinedReducers as getCombinedMccFollowupClaimReducers} from './marketing/mass-channel-customer-followup/reducers';
import {getCombinedReducers as getCombinedNormalClaimReducers} from './normal/reducers';
import {getCombinedReducers as getCombinedPartsClaimReducers} from './parts/reducers';
import {getCombinedReducers as getCombinedPipClaimReducers} from './pip/reducers';
import {getCombinedReducers as getCombinedSpaClaimReducers} from './spa/reducers';
import {getCombinedReducers as getCombinedTrackClaimReducers} from './track/reducers';
import {getCombinedReducers as getCombinedWearPartsClaimReducers} from './wear-parts/reducers';
import goodsInstallationVatOptions from './shared/reducers/goods-installation-vat-options';
import laborLocations from './shared/reducers/labor-locations';
import laborTypes from './shared/reducers/labor-types';
import otherCreditDescriptions from './shared/reducers/other-credit-descriptions';
import ownershipStatus from './shared/reducers/ownership-status';
import partUseUnits from './shared/reducers/part-use-units';
import partsGroupedByPartNumber from './shared/reducers/part-details';
import searchDropDown from './shared/reducers/search-by-dropdown';
import searchQueryString from './shared/reducers/search-query-string';

export const getCombinedReducers = () => combineReducers({
    allClaims: getCombinedAllClaimsReducers(),
    attachment: getCombinedAttachmentClaimReducers(),
    battery: getCombinedBatteryClaimReducers(),
    claimSearch: getCombinedClaimSearchReducers(),
    claimsInProgress: getCombinedClaimsInProgressReducers(),
    dealerInvoices: getCombinedDealerInvoiceReducers(),
    downTime,
    goodsInstallationVatOptions,
    incentive: getCombinedIncentiveClaimReducers(),
    jdp: getCombinedJdpClaimReducers(),
    laborLocations,
    laborRateChange: getCombinedLaborRateChangeReducers(),
    laborRateDealers: getCombinedLaborRateDealersReducers(),
    laborTypes,
    maintenancePlan: getCombinedMaintenancePlanClaimReducers(),
    massChannelPdi: getCombinedMassChannelPdiClaimReducers(),
    massLaborRateChange: getCombinedMassLaborRateChangeReducers(),
    mccFollowup: getCombinedMccFollowupClaimReducers(),
    normal: getCombinedNormalClaimReducers(),
    otherCreditDescriptions,
    ownershipStatus,
    partUseUnits,
    parts: getCombinedPartsClaimReducers(),
    partsGroupedByPartNumber,
    pip: getCombinedPipClaimReducers(),
    searchDropDown,
    searchQueryString,
    spa: getCombinedSpaClaimReducers(),
    track: getCombinedTrackClaimReducers(),
    wearParts: getCombinedWearPartsClaimReducers()
});




// WEBPACK FOOTER //
// ./src/claim/claim-reducers.js